import React from "react";
import Link from "next/link";
import { useTranslations } from '../../locales/useTranslations';
import { BiSolidEnvelope } from "react-icons/bi";

const KiMainBanner = () => {
  const { t } = useTranslations();
  return (
    <>
      <div className="mainbanner">
        <div className="ai-ml-banner">
          <div className="container">
            <div className="ai-ml-banner-content">
              <h1
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="1200"
              >
                {t('ki_mainBanner_title')}
              </h1>
              <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="1200">
                {t('ki_mainBanner_description')}
              </p>
              <div
                data-aos="fade-up"
                data-aos-delay="300"
                data-aos-duration="1200"
              >
                <Link href="/kontakt" className="default-btn">
                  <BiSolidEnvelope /> {t('ki_mainBanner_contact')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default KiMainBanner;
